
export const GET_MASTERS_START='GET_MASTERS_START';
export const GET_MASTERS_SUCCESS='GET_MASTERS_SUCCESS';
export const GET_MASTERS_FAIL='GET_MASTERS_FAIL';
